export const MAX_GRAPHQL_INT = 2147483647;
export const MIN_GRAPHQL_INT = -2147483648;

export const isGraphqlInt = (value: unknown): value is number => {
  return (
    typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= MIN_GRAPHQL_INT &&
    value <= MAX_GRAPHQL_INT
  );
};

export const isPositiveGraphqlInt = (value: unknown): value is number => {
  return isGraphqlInt(value) && value > 0;
};
